/**
 * Written by Manish Singh on 3/29/18.
 */
import  {h,render,Component} from 'preact';
import axios from 'axios';
import supportsWebP from 'supports-webp';

let options={};
if(supportsWebP){
    options['headers'] = {
        'Accept':'image/webp, */*'
    };
}

const QGet=(url)=> axios.get(url,options).then(data=> data.data);
const QPost=(url, data)=> {
    let params = new URLSearchParams();
    for(let i in data){
        if(data.hasOwnProperty(i)){
            params.append(i, data[i]);
        }
    }
    return axios.post(url, params, options).then(data=> data.data)
};

//fetch(href).then(response => response.json())

export {QGet,QPost}


// WEBPACK FOOTER //
// ../q-goods/src/common/pfetch.jsx